import { jwtDecode } from "jwt-decode";

import { ADMIN, OWNER } from "../constants/general";

/**
 * @param {string} token stringToken
 */
export function IsExpired(token) {
  if (!token) return true;

  let numberFormated;

  try {
    let { exp } = jwtDecode(token);

    numberFormated = exp * 1000;

    return new Date(numberFormated) <= new Date();
  } catch (e) {
    return true;
  }
}

/**
 * @param {string} token stringToken
 */
export function IsAdmin(token) {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const roles = Array.isArray(decoded.roles)
      ? decoded.roles
      : Array.isArray(decoded.role)
        ? decoded.role
        : decoded.role
          ? [decoded.role]
          : [];

    return roles.includes(ADMIN);
  } catch (e) {
    return true;
  }
}

/**
 * @param {string} token stringToken
 */
export function getGroups(token) {
  if (!token) return [];

  try {
    let { groupsid } = jwtDecode(token);

    return groupsid;
  } catch (e) {
    return [];
  }
}

/**
 * @param {string} token stringToken
 */
export function IsOwner(token) {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const roles = Array.isArray(decoded.roles)
      ? decoded.roles
      : Array.isArray(decoded.role)
        ? decoded.role
        : decoded.role
          ? [decoded.role]
          : [];

    return roles.includes(OWNER);
  } catch (e) {
    return false;
  }
}

export function getName(token) {
  if (!token) return "";

  try {
    let { given_name } = jwtDecode(token);

    return given_name;
  } catch (e) {
    return "";
  }
}

export function getNetworkuser(token) {
  if (!token) return "";

  try {
    let { unique_name } = jwtDecode(token);

    return unique_name;
  } catch (e) {
    return "";
  }
}
